import { BottomDrawer } from '@zenterprise-inc/ui';
import cn from 'clsx';

import common from '@/components/survey/common/ui/styles/common.module.scss';

interface Props {
  isVisible: boolean;
  onClose: () => void;
  title: string;
  items: { year: number; disabled: boolean }[];
  onSelectYear: (year: number) => void;
}

export const YearDrawer = ({ onSelectYear, items, title, isVisible, onClose }: Props) => {
  return (
    <BottomDrawer.Basic isVisible={isVisible} onCloseDrawer={onClose}>
      <BottomDrawer.Basic.Header isCloseButton onCloseDrawer={onClose}>
        {title}
      </BottomDrawer.Basic.Header>
      <BottomDrawer.Basic.Contents>
        <ul>
          {items.map(({ year, disabled }) => (
            <li
              key={year}
              aria-disabled={disabled}
              className={cn(common.drawer_list)}
              onClick={() => {
                if (disabled) return;
                onSelectYear(year);
                onClose();
              }}
            >
              <p
                className={cn(common.drawer_list_item, {
                  'opacity-40': disabled
                })}
              >
                {year}
              </p>
            </li>
          ))}
        </ul>
      </BottomDrawer.Basic.Contents>
    </BottomDrawer.Basic>
  );
};
